'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Browser verison of logger
 */
var WHLoggerBrowser = function () {

    /**
     * Constructor
     * @param {string} name Optional logger name
     * @param {Object} wh extension object
     */
    function WHLoggerBrowser() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var wh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheck3.default)(this, WHLoggerBrowser);

        this.name = name;
        this.wh = wh;
    }

    /**
     * Generic log method
     * @param {string} methodName Log method name
     * @param {Array<any>} args Arguments to be logged
     * @returns {void}
     */


    (0, _createClass3.default)(WHLoggerBrowser, [{
        key: 'log',
        value: function log(methodName) {
            if (process.env.NODE_ENV !== 'production') {
                var _console;

                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                (_console = console)[methodName].apply(_console, ['[' + this.name + ']'].concat(args));
            }
        }

        /**
         * Trace log
         * @param {Array<*>} args Array of objects to log
         * @returns {void}
         */

    }, {
        key: 'trace',
        value: function trace() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            this.log.apply(this, ['trace'].concat(args));
        }
        /**
         * Debug log
         * @param {Array<*>} args Array of objects to log
         * @returns {void}
         */

    }, {
        key: 'debug',
        value: function debug() {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            this.log.apply(this, ['debug'].concat(args));
        }
        /**
         * Info log
         * @param {Array<*>} args Array of objects to log
         * @returns {void}
         */

    }, {
        key: 'info',
        value: function info() {
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            this.log.apply(this, ['info'].concat(args));
        }
        /**
         * Warn log
         * @param {Array<*>} args Array of objects to log
         * @returns {void}
         */

    }, {
        key: 'warn',
        value: function warn() {
            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            this.log.apply(this, ['warn'].concat(args));
        }
        /**
         * Error log
         * @param {Array<*>} args Array of objects to log
         * @returns {void}
         */

    }, {
        key: 'error',
        value: function error() {
            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                args[_key6] = arguments[_key6];
            }

            this.log.apply(this, ['error'].concat(args));
        }
        /**
         * Fatal log
         * @param {Array<*>} args Array of objects to log
         * @returns {void}
         */

    }, {
        key: 'fatal',
        value: function fatal() {
            for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                args[_key7] = arguments[_key7];
            }

            this.log.apply(this, ['error'].concat(args));
        }
    }]);
    return WHLoggerBrowser;
}();

exports.default = {
    getLogger: function getLogger(categoryName, whExtends) {
        return new WHLoggerBrowser(categoryName, whExtends);
    }
};
//# sourceMappingURL=WHLoggerBrowser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/logger/dist/main/WHLoggerBrowser.js
// module id = 470
// module chunks = 0